import store from '@/store';
import {SenderEventTrack} from '@threegene/track';
window._hmt = window._hmt || [];

// 埋点的配置信息
const statisticsList = {
  result: {
    jieguoye_v: ['pingce_jieguoye_v', '发育评测结果页-发育评测结果页访问'],
    jieguoye_wenzhang_s: ['pingce_jieguoye_wenzhang_s', '发育评测结果页-文章曝光'],
    jieguoye_wenzhang_c: ['pingce_jieguoye_wenzhang_c', '发育评测结果页-文章点击'],
    jieguoye_kecheng_s: ['pingce_jieguoye_kecheng_s', '发育评测结果页-课程曝光'],
    jieguoye_kecheng_c: ['pingce_jieguoye_kecheng_c', '发育评测结果页-课程点击'],
    jieguoye_zixun_s: ['pingce_jieguoye_zixun_s', '发育评测结果页-咨询曝光'],
    jieguoye_zixun_c: ['pingce_jieguoye_zixun_c', '发育评测结果页-咨询点击'],
    jieguoye_chongxinpingce_s: ['pingce_jieguoye_chongxinpingce_s', '发育评测结果页-重新评测曝光'],
    jieguoye_chongxinpingce_c: ['pingce_jieguoye_chongxinpingce_c', '发育评测结果页-重新评测点击'],
    jieguoye_fenxiang_s: ['ceping_fenxiang_s', '测评结果页-分享按钮曝光'],
    jieguoye_fenxiang_c: ['ceping_fenxiang_c', '测评结果页-分享按钮点击'],
    cepingjieguo_gengduo_s: ['cepingjieguo_gengduo_s', '测评结果页-更多测评曝光'],
    cepingjieguo_gengduo_c: ['cepingjieguo_gengduo_c', '测评结果页-更多测评点击'],
    cepingjieguo_pingjia_c: ['cepingjieguo_pingjia_c', '测评结果页-评价点击'],
    cepingjieguo_pingjiatankuang_c: ['cepingjieguo_pingjiatankuang_c', '测评结果页--发表评价弹框按钮点击']
  }
};
// 所有数据统计列表
let list = {};
for (const key in statisticsList) {
  list = {...list, ...statisticsList[key]};
}

// 百度统计
function baiduStatistics(params) {
  window._hmt.push(['_trackEvent'].concat(params));
}

// 大数据统计
function bigDataStatistics(name, params) {
  window.$sender.track('manualTrack', params, name);
}

// 对外暴露统计方法
export const statistics = {
  login: function () {
    const {id} = store.getters['global/userInfo'] || {};
    // eslint-disable-next-line no-undef
    SenderEventTrack.login(id);
  },
  trackPoint: function (name, params) {
    const {id} = store.getters['global/userInfo'] || {};
    const {childId} = store.state.child || {};
    const {projectId, assessType} = store.state.assess || {};
    // 默认必传参数
    const defaultParams = {
      _ui: id, // 用户id
      childid: childId, // 儿童id
      id: projectId, // 评测id
      articleids: '', // 文章id
      sectionid: '', // 课程id
      type: assessType, // 评测类型
      navid: '' // 推荐id
    };
    if (!name || !list[name]) return;
    if (params) {
      params = {...defaultParams, ...params};
    } else {
      params = defaultParams;
    }
    const baiduParams = [];
    baiduParams[0] = list[name][1];
    baiduParams[1] = JSON.stringify(params);
    baiduStatistics(baiduParams);
    bigDataStatistics(list[name][0], params);
  },
  moreAssessTrackPoint: function (name, params) {
    if (list[name]) {
      const {childId} = store.state.child || {};
      params.childID = childId;
      bigDataStatistics(list[name][0], params);
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/config/statistics.js